module.exports = __webpack_public_path__ + "media/Components/fonts/PlayfairDisplay-34a18e8fb1c1542162f56918f7f61e3c.ttf";